/**
 * London Smoke & Cure — Njord shared constants (UI + services).
 */

export const NJORD_DEFAULT_READ_INTERVAL_SEC = 15;
/** Missed check-ins before UI leaves "online" (4 × 15s ≈ 1 min — allows one late loop). */
export const NJORD_PRESENCE_ONLINE_INTERVALS = 4;
/** Missed check-ins before UI shows offline (10 × 15s ≈ 2.5 min). Between = "Waiting". */
export const NJORD_PRESENCE_OFFLINE_INTERVALS = 10;
export const NJORD_DEFAULT_CALIBRATION_REVIEW_DAYS = 180;
export const NJORD_PAIRING_WINDOW_MIN = 5;
/** Max WiFi networks in desired config (matches firmware NJORD_WIFI_MAX_NETS). */
export const NJORD_WIFI_MAX_NETWORKS = 4;
export const NJORD_HISTORY_DEFAULT_LIMIT = 500;
export const NJORD_EVENTS_DEFAULT_LIMIT = 100;
export const NJORD_SNOOZE_PRESETS_SEC = {
    '1h': 3600,
    '4h': 14400,
    until_in_range: 0,
};

export const NJORD_EVENT_CATEGORIES = {
    ALERT: 'njord.alert',
    COMMAND: 'njord.command',
    REGISTER: 'njord.register',
    ROOM: 'njord.room.member',
    CALIBRATION: 'njord.calibration',
    CONFIG: 'njord.config',
};

/** Operator sign-off: Phase 1 (Firebase RTDB + rules) is complete. */
export const NJORD_PHASE_1_COMPLETE = true;

/**
 * Force Phase 1 verification UI on (debug / new environment).
 * Future phase checklists: add similar flags or a phase entry in NJORD_ACTIVATION_UI.
 */
export const NJORD_SHOW_PHASE1_VERIFICATION_UI = false;

/** Production mode — hide first-sensor banners and default Setup to provisioning. */
export const NJORD_GO_LIVE_TESTING = false;
